/*
 * Copyright (c) 2024, King Living
 * Cart Flyout Theme Styles
 */

import {keyframes} from '@emotion/react';

// CSS keyframes for cart item swipe hint animation
// Animation cycle: 2s wait, 1s bounce animation, then repeat
export const swipeHintBounce = keyframes`
  0% {
    transform: translateX(0);
  }
  66.67% {
    transform: translateX(0);
  }
  75% {
    transform: translateX(-10px);
  }
  83.33% {
    transform: translateX(4px);
  }
  91.67% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0);
  }
`;

const CartFlyout = {
  parts: [
    'overlay',
    'content',
    'header',
    'logo',
    'title',
    'itemCount',
    'body',
    'itemsContainer',
    'itemsList',
    'deleteButton',
    'loadingState',
    'emptyState',
    'emptyText',
    'summaryContainer'
  ],
  baseStyle: {
    overlay: {
      backdropFilter: 'blur(8px)',
      bg: 'blackAlpha.300',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: {base: '100%', lg: '500px'},
    },
    header: {
      borderBottom: '1px solid',
      borderColor: 'gray.200',
      padding: {base: 4, md: 6},
    },
    logo: {
      display: {base: 'block', lg: 'none'},
      height: 'auto',
      width: '76px',
    },
    logoSvg: {
      '& svg': {
        display: 'block',
        height: 'auto',
        width: '100%',
      },
    },
    title: {
      fontSize: {base: 'xl', md: '2xl'},
      fontWeight: 'bold',
    },
    itemCount: {
      color: 'gray.600',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 'normal',
    },
    body: {
      flex: 1,
      overflow: 'hidden',
    },
    itemsContainer: {
      flex: 1,
      overflowY: 'auto',
    },
    itemsList: {
      '@media (max-width: 1023px)': {
        '& > *:first-child .swipeable-item-content': {
          animation: `${swipeHintBounce} 2.5s ease-in-out infinite`,
        },
      },
    },
    deleteButton: {
      alignItems: 'center',
      bg: '#1b1a18', // greyscale/100 from design
      color: '#ffffff', // whites/100 from design
      display: 'flex',
      fontSize: '16px',
      fontWeight: 400, // Regular
      justifyContent: 'center',
      lineHeight: 1.2,
      padding: '10px',
    },
    loadingState: {
      padding: 6,
      textAlign: 'center',
    },
    emptyState: {
      padding: 8,
      textAlign: 'center',
    },
    emptyText: {
      color: 'gray.600',
      fontSize: 'md',
    },
    summaryContainer: {
      bg: 'white',
      borderTop: '1px solid',
      borderColor: 'gray.200',
      padding: {base: 4, md: 6},
    },
  },
};

export default CartFlyout;
